export const fetchCourseDetail = async ({ BeURL, courseId }) => {
    try {
        if (!BeURL || typeof BeURL !== 'string') {
            return {
                success: false,
                message: "Backend URL not provided or invalid"
            }
        }

        if (!courseId || typeof courseId !== 'string') {
            return {
                success: false,
                message: "Course ID not provided"
            }
        }

        const res = await fetch(`${BeURL}/fetch-course-detail?courseId=${courseId}`, {
            method: "GET",
            credentials: "include"
        })

        if (!res.ok) {
            return {
                success: false,
                message: `HTTP error! status: ${res.status}`
            }
        }

        const data = await res.json()
        return data

    } catch (error) {
        console.error("Error fetching course detail:", error)
        return {
            success: false,
            message: "An error occurred while fetching course details"
        }
    }
}
